const Welcome = () => {
  return (
    <div id="welcome">
      <div className="welcome">
        <h2 id="welcome-head">
          Get the information you need to be an engaged citizen.
        </h2>
        <p>Find and contact your elected officials.</p>
        <p>See how your members of Congress voted on important issues.</p>
      </div>
    </div>
  );
};

export default Welcome;
